import React from 'react'
import PropTypes from 'prop-types'
import classes from './SelectCellColored.module.css'

const SelectCellColored = ({ value, onChange, options }) => {
  return (
    <select
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      className={classes.select}
      style={{
        backgroundColor:
          options.find(opt => Number(Object.keys(opt)[0]) === Number(value))
            ?.color || 'transparent',
      }}
    >
      {value ?? (
        <option value="" disabled hidden>
          -
        </option>
      )}

      {options.map((opt, index) => {
        const key = Object.keys(opt)[0]
        const label = opt[key]
        const color = opt.color

        return (
          <option key={key} value={key} style={{ backgroundColor: color }}>
            {label}
          </option>
        )
      })}
    </select>
  )
}

SelectCellColored.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default SelectCellColored
